import {MenuButton} from '#/components/buttons/menu-button';
import {BalanceCard} from '#/components/header/balance-card';
import {HeaderSearchButton, HeaderSearchCloseButton} from '#/components/header/header-atoms';
import HeaderSearchBar from '#/components/header/header-search-bar';
import {ShareLandLogoLink} from '#/components/header/share-land-logo-link';
import {WalletInfo} from '#/components/header/wallet-info';
import {useWalletProvider} from '#/contexts/wallet-provider';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {Land, UnlistedLand} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {useToggle} from 'react-use';

type HeaderProps = {onSearch: (land: Land | UnlistedLand) => void};

export const Header: FunctionComponent<HeaderProps> = ({onSearch}) => {
  const [isSearchOpen, toggleIsSearchOpen] = useToggle(false);
  const {t} = useTranslation('translation');
  const {
    accountResult: {isConnected},
  } = useWalletProvider();

  return (
    <header className={'h-header w-full bg-grayblue px-5'}>
      {isSearchOpen ? (
        <div className='flex h-full gap-3'>
          <HeaderSearchBar autoFocus className='grow' onSearch={onSearch} onBlur={toggleIsSearchOpen} />
          <HeaderSearchCloseButton onClick={toggleIsSearchOpen} />
        </div>
      ) : (
        <div className='w-full h-full flex justify-between items-center max-w-screen-3xl mx-auto'>
          <div className='grow flex h-full items-center gap-4'>
            <MenuButton mode='open' />
            <ShareLandLogoLink />
            <HeaderSearchBar className='hidden lg:block grow' onSearch={onSearch} />
            <HeaderSearchButton className='lg:hidden' onClick={toggleIsSearchOpen} />
          </div>
          {/* <HeaderFilter /> */}
          <Link
            to={ExchangeRoute.HOW_IT_WORKS_NOTION}
            target='_blank'
            className='h-full text-white justify-center items-center px-4 hover:opacity-70 hover:cursor-pointer hidden md:flex'
          >
            {t('pages.landing.howItWorks.title')}
          </Link>
          <div className='flex h-full items-center gap-3'>
            {isConnected && <BalanceCard />}
            <WalletInfo />
          </div>
        </div>
      )}
    </header>
  );
};
